import React from 'react';

import { Inline } from '@styleseat/ui';
import {
  HeaderText,
  Stack,
  Touchable,
} from '../../ui';
import analytics from '../../../modules/analytics';

import styles from './PaymentsBanner.module.scss';

const PaymentsBanner: React.FC<{}> = () => {
  const handleClick = () => {
    analytics.track('client_home_payments_banner_clicked');
  };

  return (
    <Touchable accessibilityRole="text" onClick={handleClick} testID="payments-banner-container">
      <Stack style={{ cursor: 'auto' }}>
        <Inline
          className={styles['animate-fadein-loop']}
          space={16}
          alignItems="center"
          justifyContent="center"
          minHeight={41}
          minWidth={375}
          flexWrap="nowrap"
        >
          {[
            'Discover',
            'Book',
            'Pay',
            'Repeat',
          ].map((word, idx) => (
            <HeaderText level={2} className={styles[`item-${idx}`]} key={word}>
              {word}.
            </HeaderText>
          ))}
        </Inline>
      </Stack>
    </Touchable>
  );
};

export default PaymentsBanner;
